/*紫微斗數 Chinese Astrology Zi Wei Dou Shu*/
/*天干地支五行局*/
var YinYang=["阳","阴"];
var HeavenlyStems=["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"];
var ShengXiaoGB=["鼠", "牛", "虎", "兔", "龙", "蛇","马", "羊", "猴", "鸡", "狗", "猪"];
var EarthlyBranches=["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"];
var Palace=["【命宫】","【父母宫】","【福德宫】","【田宅宫】","【官禄宫】","【交友宫】","【迁移宫】","【疾厄宫】","【财帛宫】","【子女宫】","【夫妻宫】","【兄弟宫】","【身】"];
var FiveElements=["水二局","火六局","土五局","木三局","金四局"];
var DaShian=[2,6,5,3,4];//搭配五行局
/*Stars*/
var StarM_A14=["紫微","天机","太阳","武曲","天同","廉贞","天府","太阴","贪狼","巨门","天相","天梁","七杀","破军"];
var StarM_A07=["文昌","文曲","左辅","右弼","天魁","天钺","禄存"];
var StarM_S04=["化祿","化權","化科","化忌"];
var StarM_B06=["擎羊","陀罗","火星","铃星","地空","地劫"];
var StarO_S05=["天马","龙池","凤阁","红鸾","天喜"];
/*0:水二局:[1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,0,0,1,1,2,2,3,3,4]
  3:木三局:[4,1,2,5,2,3,6,3,4,7,4,5,8,5,6,9,6,7,10,7,8,11,8,9,0,9,10,1,10,11]
  4:金四局:[11,4,1,2,0,5,2,3,1,6,3,4,2,7,4,5,3,8,5,6,4,9,6,7,5,10,7,8,6,11]
  2:土五局:[6,11,4,1,2,7,0,5,2,3,8,1,6,3,4,9,2,7,4,5,10,3,8,5,6,11,4,9,6,7]
  1:火六局:[9,6,11,4,1,2,10,7,0,5,2,3,11,8,1,6,3,4,0,9,2,7,4,5,1,10,3,8,5,6]*/
var FiveEleTable=[
	[1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,0,0,1,1,2,2,3,3,4],
	[9,6,11,4,1,2,10,7,0,5,2,3,11,8,1,6,3,4,0,9,2,7,4,5,1,10,3,8,5,6],
	[6,11,4,1,2,7,0,5,2,3,8,1,6,3,4,9,2,7,4,5,10,3,8,5,6,11,4,9,6,7],
	[4,1,2,5,2,3,6,3,4,7,4,5,8,5,6,9,6,7,10,7,8,11,8,9,0,9,10,1,10,11],
	[11,4,1,2,0,5,2,3,1,6,3,4,2,7,4,5,3,8,5,6,4,9,6,7,5,10,7,8,6,11]];
var FiveEleArr=[[0,1,3,2,4,1],[1,2,4,3,0,2],[2,3,0,4,1,3],[3,4,1,0,2,4],[4,0,2,1,3,0]];
	
//StarM_A14 => 0:紫微,1:天機,2:太陽,3:武曲,4:天同,5:廉貞,6:天府,7:太陰,8:貪狼,9:巨門,10:天相,11:天梁,12:七殺,13:破軍
var Star_A14=[
	[[0],[],[13],[],[5,6],[7],[8],[4,9],[3,10],[2,11],[12],[1]],
	[[1],[0,13],[],[6],[7],[5,8],[9],[10],[4,11],[3,12],[2],[]],
	[[13],[1],[0,6],[7],[8],[9],[5,10],[11],[12],[10],[3],[2]],
	[[2],[6],[1,7],[0,8],[9],[10],[11],[5,12],[],[],[4],[3,13]],
	[[3,6],[2,7],[8],[1,9],[0,10],[11],[12],[],[5],[],[13],[4]],
	[[4,7],[3,8],[2,9],[10],[1,10],[0,12],[],[],[],[5,13],[],[6]],
	[[8],[4,9],[3,10],[2,11],[12],[1],[0],[],[13],[],[5,6],[7]],
	[[9],[10],[4,11],[3,12],[2],[],[1],[0,13],[],[6],[7],[5,8]],
	[[5,10],[11],[12],[10],[3],[2],[13],[1],[0,6],[7],[8],[9]],
	[[11],[5,12],[],[],[4],[3,13],[2],[6],[1,7],[0,8],[9],[10]],
	[[12],[],[5],[],[13],[4],[3,6],[2,7],[8],[1,9],[0,10],[11]],
	[[],[],[],[5,13],[],[6],[4,7],[3,8],[2,9],[10],[1,10],[0,12]]
];
//安紫微諸星表，第7列，[6]為天府
var Star_Z06=[
	[0,1,2,3,4,5,6,7,8,9,10,11],
	[11,0,1,2,3,4,5,6,7,8,9,10],
	[9,10,11,0,1,2,3,4,5,6,7,8],
	[8,9,10,11,0,1,2,3,4,5,6,7],
	[7,8,9,10,11,0,1,2,3,4,5,6],
	[4,5,6,7,8,9,10,11,0,1,2,3],
	[4,3,2,1,0,11,10,9,8,7,6,5]
];
var Star_T08=[
	[0,1,2,3,4,5,6,7,8,9,10,11],
	[1,2,3,4,5,6,7,8,9,10,11,0],
	[2,3,4,5,6,7,8,9,10,11,0,1],
	[3,4,5,6,7,8,9,10,11,0,1,2],
	[4,5,6,7,8,9,10,11,0,1,2,3],
	[5,6,7,8,9,10,11,0,1,2,3,4],
	[6,7,8,9,10,11,0,1,2,3,4,5],
	[10,11,0,1,2,3,4,5,6,7,8,9]
];
//StarM_A07=new Array("文昌","文曲","左輔","右弼","天魁","天鉞","祿存");
//0:文昌 1:文曲 (時) 2:左輔 3:右弼 (月) 4:天魁 5:天鉞 6:祿存(年干)
var Star_G07=[
	[10,9,8,7,6,5,4,3,2,1,0,11],
	[4,5,6,7,8,9,10,11,0,1,2,3],
	[4,5,6,7,8,9,10,11,0,1,2,3],
	[10,9,8,7,6,5,4,3,2,1,0,11],
	[1,0,11,11,1,0,1,6,3,3],
	[7,8,9,9,7,8,7,2,5,5],
	[2,3,5,6,5,6,8,9,11,0]
];
//StarM_S04=new Array("化祿","化權","化科","化忌");
//0:紫微,1:天機,2:太陽,3:武曲,4:天同,5:廉貞,6:天府,7:太陰,8:貪狼,9:巨門,10:天相,11:天梁,12:七殺,13:破軍
//0:文昌 1:文曲 (時) 2:左輔 3:右弼 (月) 4:天魁 5:天鉞 6:祿存(年干)
//0:化祿 1:化權 2:化科 3:化忌

// —— 1) 幫手：星名 → 取用對象（十四主星 or 六吉星）——
const A14 = StarM_A14; // 14 主星
const A07 = StarM_A07; // 文昌、文曲、左輔、右弼、天魁、天鉞、祿存

function pickStar(name){
  // 優先在 14 主星找，找不到再到 A07 找
  const i14 = A14.indexOf(name);
  if (i14 >= 0) return A14[i14];
  const i07 = A07.indexOf(name);
  if (i07 >= 0) return A07[i07];
  throw new Error("Unknown star name in S04 mapping: " + name);
}

// —— 2) 年干 → 四化對應（請把這裡改成你要的正確表）——
// 以「干字」為 key；L/Q/K/J 分別代表 祿/權/科/忌。
// 範例：下方只是示意，請換成你認同的權威對照表。

const S04_MAP = {
	"甲": { L:"廉贞", Q:"破军", K:"武曲", QI:"太阳" },
	"乙": { L:"天机", Q:"天梁", K:"紫微", QI:"太阴" },
	"丙": { L:"天同", Q:"天机", K:"文昌", QI:"廉贞" },
	"丁": { L:"太阴", Q:"天同", K:"天机", QI:"巨门" },
	"戊": { L:"贪狼", Q:"太阴", K:"右弼", QI:"天机" },
	"己": { L:"武曲", Q:"贪狼", K:"天梁", QI:"文曲" },
	"庚": { L:"太阳", Q:"武曲", K:"天同", QI:"天相" },
	"辛": { L:"巨门", Q:"太阳", K:"文曲", QI:"文昌" },
	"壬": { L:"天梁", Q:"紫微", K:"左辅", QI:"武曲" },
	"癸": { L:"破军", Q:"巨门", K:"太阴", QI:"贪狼" }
  };


// —— 3) 轉成 4×10 的 Star_S04 ——
// 列序：0=祿 1=權 2=科 3=忌；欄序：0..9 = 甲乙丙丁戊己庚辛壬癸
const STEMS = ["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"];
var Star_S04 = [[], [], [], []];

for (let j=0; j<STEMS.length; j++){
  const m = S04_MAP[STEMS[j]];
  if (!m) throw new Error("Missing S04 mapping for stem: " + STEMS[j]);
  Star_S04[0][j] = pickStar(m.L);  // 化祿
  Star_S04[1][j] = pickStar(m.Q);  // 化權
  Star_S04[2][j] = pickStar(m.K);  // 化科
  Star_S04[3][j] = pickStar(m.QI); // 化忌
}


//StarM_B06=new Array("擎羊","陀羅","火星","鈴星","天空","地劫");
//0:擎羊 1:陀羅 2:火星 3:鈴星 4:天空 5:地劫
//0:2,6,10 1:8,0,4 2:5,9,1 3:11,3,7  %4=> 2,0,1,3
//改成0:8,0,4 1:5,9,1 2:2,6,10 3:11,3,7 
var Star_B06=[
	[3,4,6,7,6,7,9,10,0,1],
	[1,2,4,5,4,5,7,8,10,11],
	[[2,3,4,5,6,7,8,9,10,11,0,1],[3,4,5,6,7,8,9,10,11,0,1,2],[1,2,3,4,5,6,7,8,9,10,11,0],[9,10,11,0,1,2,3,4,5,6,7,8]],
	[[10,11,0,1,2,3,4,5,6,7,8,9],[10,11,0,1,2,3,4,5,6,7,8,9],[3,4,5,6,7,8,9,10,11,0,1,2],[10,11,0,1,2,3,4,5,6,7,8,9]],
	[11,10,9,8,7,6,5,4,3,2,1,0],
	[11,0,1,2,3,4,5,6,7,8,9,10]
];
//StarO_S05=new Array("天馬","龍池","鳳閣","紅鸞","天喜"");
var Star_OS5=[
	[2,11,8,5,2,11,8,5,2,11,8,5],
	[4,5,6,7,8,9,10,11,0,1,2,3],
	[10,9,8,7,6,5,4,3,2,1,0,11],
	[3,2,1,0,11,10,9,8,7,6,5,4],
	[9,8,7,6,5,4,3,2,1,0,11,10]
];
